module.exports = __webpack_public_path__ + "img/floor-merchant1.fd93235a.png";